import { Icon, type IconProps } from './Icon';

export function QueryIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M4 6h10M4 12h6M4 18h6" />
      <circle cx="16" cy="15" r="3" />
      <path d="m21 20-2.8-2.8" />
    </Icon>
  );
}
